import { PIAPIVersion } from "@/apiConfig";
import { piserverApiUrl } from "@/environment";
import { createApiClient } from "@/services/apiClient";

export class SupportHandler {
  constructor() {
    this.client = createApiClient(piserverApiUrl);
  }

  // Returns the server log bundle (support.tar.gz) as a Blob, streamed from the
  // piserver HTTP bridge (on-prem only).
  getTar() {
    return this.client.get(`ch/rentouch/piplanning/${PIAPIVersion}/support/get_tar/`, {
      responseType: "blob",
    });
  }
}
